import { PUBLIC_FIREBASE_VAPID_KEY } from '$env/static/public';

/**
 * Configurazione Web pubblica del progetto Firebase `app-v3-59b7e`
 * (lo stesso usato dalle app mobile e dal servizio di invio `ilpostino`).
 *
 * Questi valori sono pubblici per natura: finiscono comunque nel bundle client.
 * Sono identici in tutti gli ambienti (progetto Firebase unico), quindi sono qui come costanti.
 *
 * NB: il service worker statico `static/firebase-messaging-sw.js` NON può importare questo modulo
 * (Vite non processa la cartella `static/`). Riceve la stessa config via query string al momento
 * della registrazione (vedi `push-notifications.js`). Tenere allineati i due punti.
 */
export const firebaseConfig = {
  apiKey: 'AIzaSyDuQS6p3palcrk93CwO1ayNnPNw5RR7z5Q',
  authDomain: 'app-v3-59b7e.firebaseapp.com',
  projectId: 'app-v3-59b7e',
  storageBucket: 'app-v3-59b7e.firebasestorage.app',
  messagingSenderId: '311912874332',
  appId: '1:311912874332:web:ce898790f761488426c199'
};

/** Chiave VAPID (Web Push certificate) del progetto, da env. */
export const VAPID_KEY = PUBLIC_FIREBASE_VAPID_KEY;
